export const ko = {
  lang: 'ko',
  accessibility: {
    info: '안내',
    success: '성공',
    warning: '경고',
    error: '오류',
    close: '닫기',
    page: '페이지',
    prev: '이전',
    next: '다음',
    back: '뒤로',
  },
  ConfirmModal: {
    title: '알림',
    confirmText: '확인',
    cancelText: '취소',
  },
  AlertModal: {
    title: '알림',
    confirmText: '확인',
  },
  NoticeModal: {
    closeText: '닫기',
    checkReplayText: '오늘 하루동안 이 창을 열지 않음',
  },
  CheckboxGroup: {
    all: '전체',
  },
  Dropdown: {
    placeholder: '선택',
    filterPlaceholder: '필터 검색',
  },
  DropdownFilter: {
    reset: '초기화',
    confirm: '적용',
    all: '전체',
  },
  DatePicker: {
    placeholder: '날짜를 선택하세요.',
    footer: {
      now: '지금',
      today: '오늘',
      ok: '확인',
      clear: '취소',
    },
  },
  DatePickerRange: {
    placeholder: ['시작일', '종료일'],
    dataPreset: {
      'today': '오늘',
      '1-week': '1주일',
      '1-month': '1개월',
      '3-month': '3개월',
      '6-month': '6개월',
      '1-year': '1년',
      'all': '전체',
    },
  },
  TimePicker: {
    placeholder: '시간을 선택하세요.',
    footer: {
      ok: '확인',
      clear: '취소',
    },
    unit: {
      hour: '시',
      minute: '분',
    },
    disabledTooltipText: '날짜를 먼저 선택해주세요.',
  },
  TimeRangePicker: {
    placeholder: ['시작시간', '종료시간'],
  },
  FileUpload: {
    label: '파일 업로드',
  },
  ImageUpload: {
    label: '이미지 업로드',
    fail: '이미지 업로드 실패',
  },
  Table: {
    noDataText: '데이터가 없습니다.',
  },
  ColumnViewController: {
    noFixedItemsText: '고정 정보가 없습니다.',
    fixedSectionTitle: '고정 정보',
    listSectionTitle: '목록 정보',
    max: '최대',
    items: '개',
  },
  CategorySelector: {
    levelCategory: '차 카테고리',
    selectParentCategoryLine1: '상위 카테고리를',
    selectParentCategoryLine2: '선택해 주세요.',
  },
};
